import { request } from '../../../lib/request_cms';
//新增手动备份
export function backupSave(data, params = {}) {
    return request({
        url: '/mwebapi/sysconfig/backup/save',
        method: 'post',
        data,
        params
    });
}
//列表
export function backupList(params) {
    return request({
        url: '/mwebapi/sysconfig/backup/list',
        method: 'get',
        params,
    });
}
//还原
export function resetFun(data, params = {}) {
    return request({
        url: '/mwebapi/sysconfig/backup/restore',
        method: 'post',
        data,
        params
    });
}
//删除
export function deleteData(data) {
    return request({
        url: '/mwebapi/sysconfig/backup/delete',
        method: 'post',
        data,
    });
}
//查询状态
export function checkBackupRestoreStatus(params) {
    return request({
        url: 'mwebapi/sysconfig/backup/checkBackupRestoreStatus',
        method: 'get',
        params,
    });
}
//校验重名
export function queryByBackupName(data) {
    return request({
        url: '/mwebapi/sysconfig/backup/queryByBackupName',
        method: 'post',
        data,
    });
}

/**
 * 查看备份明细
 * @param {{batchUuid: string}} params 
 */
export function listProductBackupDetail(params) {
    return request({
        url: '/mwebapi/sysconfig/backup/listProductBackupDetail',
        method: 'get',
        params
    })
}

/**
 * 查看备份上限
 */
export function getBackupQuota() {
    return request({
        url: '/mwebapi/sysconfig/backup/getBackupQuota',
        method: 'get'
    });
}

/**
 * 终止备份
 * @param {{backupUuid: string}} params 
 */
export function abortBackup(params) {
    return request({
        url: '/mwebapi/sysconfig/backup/abortBackup',
        method: 'get',
        params
    });
}